import axios from 'axios';
import { toast } from 'react-toastify';

const instance = axios.create({
    // baseURL2: 'http://192.168.0.110:8000/',
    baseURL: 'https://logistika.smart-trade.uz/api/',
    // baseURL: 'http://192.168.0.110:8000/api/',
    baseURL2: 'https://logistika.smart-trade.uz/',
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor
instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
instance.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;
        const success = error.response?.data?.success;

        if (status === 401) {
            localStorage.removeItem("token");
            window.location.href = '/login';
        }
        // else if (error.response) {
        //     // Agar success false bo‘lsa, toast chiqarsin
        //     if (success === false) {
        //         const message = error.response?.data?.message || "Xatolik yuz berdi";
        //         toast.error(message);
        //     } else {
        //         // Boshqa xatoliklar uchun default toast
        //         toast.error("Serverdan noto‘g‘ri javob keldi");
        //     }
        // }
        // else {
        //     // Backend umuman ishlamayapti (masalan, server down bo‘lsa)
        //     window.location.href = '/error';
        // }

        return Promise.reject(error);
    }
);
// instance.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response?.status === 401) {
//             localStorage.removeItem("token");
//             window.location.href = '/login';
//         }else if (error.response?.success === false || error.response?.status >= 400) {
//             // Agar boshqa xatolik bo‘lsa
//             window.location.href = '/error';
//         }
//         return Promise.reject(error);
//     }
// );

export default instance;
